export enum FollowUpQuestionStatus {
  Pending = 'pending',
  Resolved = 'resolved',
  NotFit = 'not_fit'
}

export function getFollowUpQuestionStatusLabel(status: FollowUpQuestionStatus) {
  switch (status) {
    case FollowUpQuestionStatus.Pending:
      return 'Pending';
    case FollowUpQuestionStatus.Resolved:
      return 'Qualified';
    case FollowUpQuestionStatus.NotFit:
      return 'Unmet';
  }
}

type StatusColor = {
  FontColor: string;
  BorderColor: string;
  BackgroundColor: string;
};

const statusColors: Record<FollowUpQuestionStatus, StatusColor> = {
  [FollowUpQuestionStatus.Pending]: {
    FontColor: '#AB7207',
    BorderColor: '#ECDBA5',
    BackgroundColor: '#FFFDF2'
  },
  [FollowUpQuestionStatus.Resolved]: {
    FontColor: '#4E76FF',
    BorderColor: '#CAD6FF',
    BackgroundColor: '#F6F8FF'
  },
  [FollowUpQuestionStatus.NotFit]: {
    FontColor: '#D92D20',
    BorderColor: '#FECDCA',
    BackgroundColor: '#FEF3F2'
  }
};

export function getFollowUpQuestionStatusColor(status: FollowUpQuestionStatus) {
  return statusColors[status];
}
